import { render, staticRenderFns } from "./AllProducts.vue?vue&type=template&id=04f383de&scoped=true"
import script from "./AllProducts.vue?vue&type=script&lang=js"
export * from "./AllProducts.vue?vue&type=script&lang=js"
import style0 from "./AllProducts.vue?vue&type=style&index=0&id=04f383de&prod&lang=scss&scoped=true"
import style1 from "./AllProducts.vue?vue&type=style&index=1&id=04f383de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f383de",
  null
  
)

export default component.exports